import { render, staticRenderFns } from "./FileVerificationExpired.vue?vue&type=template&id=00604e34&scoped=true&"
import script from "./FileVerificationExpired.vue?vue&type=script&lang=js&"
export * from "./FileVerificationExpired.vue?vue&type=script&lang=js&"
import style0 from "./FileVerificationExpired.vue?vue&type=style&index=0&id=00604e34&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00604e34",
  null
  
)

export default component.exports